import { FC } from 'react';

import { SubmissionListResponseOutputItemsItem } from '@/api/generated';
import { SubmissionsTableEmptyRow } from '@/components/blocks/submissions/submissions-table-empty-row';
import { SubmissionsTableRow } from '@/components/blocks/submissions/submissions-table-row';
import { TableBody } from '@/components/ui/table';
import { cn } from '@/lib/utils';

interface SubmissionsTableBodyProps {
  className?: string;
  submissions: Array<SubmissionListResponseOutputItemsItem>;
  customerId: string;
}

export const SubmissionsTableBody: FC<SubmissionsTableBodyProps> = ({
  className,
  submissions,
  customerId,
}: SubmissionsTableBodyProps) => (
  <TableBody
    className={cn(
      'divide-outline-variant divide-y [&_tr:last-child]:border-primary',
      className
    )}>
    {submissions.length === 0 ? (
      <SubmissionsTableEmptyRow />
    ) : (
      submissions.map((submission) => (
        <SubmissionsTableRow
          key={submission.id}
          submission={submission}
          customerId={customerId}
        />
      ))
    )}
  </TableBody>
);
